import { OnSuccessCallback, useCustomMutation } from './index';

import { QueryKeys } from '../queries';
import Config from '../../config';
import { METHODS } from '../constants';
import { useMarkJimNotificationsAsSeen } from './jimJobs';

export type DownloadJournalFileVariable = {
  jobId: string;
};

export const useDownloadJournalFile = (onSuccess: OnSuccessCallback<Response, DownloadJournalFileVariable>) => {
  const { mutate: markJobNotificationAsSeen } = useMarkJimNotificationsAsSeen();

  return useCustomMutation<Response, Error, DownloadJournalFileVariable>({
    handleData: ({ jobId }) => ({
      url: Config.endpoints.DOWNLOAD_JOURNAL_FILE.replace(':jobId', jobId),
      method: METHODS.GET,
    }),
    invalidateKey: query => [QueryKeys.journalFiles.DownloadJournalFile].includes(query.queryKey[0] as string),
    errorMessage: 'Generating file to download failed',
    successMessage: 'Generated journal file successfully, wait for download',
    parseResponseErrorMessage: true,
    onSuccess,
    onMutate: ({ jobId }) => markJobNotificationAsSeen([jobId]),
  });
};
